import {flashy} from "./toastFunctions";

window.psPushErrorsArr = null;

export function prom_validate_ps_push_data(data, successCallback = null, errorCallback = null) {
    window.psPushErrorsArr = null;
    return new Promise((resolve) => {
        $.ajax({
            url: '/ps_push/validate',
            type: 'post',
            dataType: 'json',
            data: {
                actions: 'ps_push/validate',
                psData: data
            },
            success: function (response) {
                if (response.status == "s0") {
                    //Success
                    if (successCallback !== null)
                        successCallback();
                    resolve(true);
                } else if (response.status == "e2") {
                    //Network error
                    flashy('Network error', response.message, 'e');
                    resolve(false);
                } else {
                    //Validation error
                    if (errorCallback !== null)
                        errorCallback();
                    window.psPushErrorsArr = response.data;
                    resolve(false);
                }
            },
            error: function (error) {
                console.log(error);
            }
        });
    });
}